<template>
  <div class="terms-container">
    <!-- 헤더 -->
    <header class="terms-header">
      <div class="terms-header-inner">
        <div class="terms-logo" @click="goHome">
          <img src="/imgs/LOGO.png" alt="BODA" />
          <span>보다</span>
        </div>
        <button class="terms-back-btn" @click="goHome">
          <i class="ph ph-arrow-left"></i> 돌아가기
        </button>
      </div>
    </header>

    <!-- 탭 -->
    <div class="terms-tab-wrap">
      <div class="terms-tabs">
        <button
          :class="['terms-tab', { active: activeTab === 'boda' }]"
          @click="activeTab = 'boda'"
        >
          보다 이용약관
        </button>
        <button
          :class="['terms-tab', { active: activeTab === 'privacy' }]"
          @click="activeTab = 'privacy'"
        >
          개인정보처리방침
        </button>
      </div>
    </div>

    <!-- 콘텐츠 -->
    <main class="terms-content">
      <div class="terms-paper">

        <!-- ===================== 보다 이용약관 ===================== -->
        <template v-if="activeTab === 'boda'">
          <div class="terms-doc-header">
            <div class="terms-doc-badge boda">이용약관</div>
            <h1>보다(BODA) 서비스 이용약관</h1>
            <p class="terms-date">시행일: 2026년 2월 23일</p>
          </div>

          <section class="terms-article" v-for="(article, idx) in bodaArticles" :key="'b-' + idx">
            <h2>{{ article.title }}</h2>
            <template v-for="(block, bIdx) in article.blocks" :key="'bb-' + idx + '-' + bIdx">
              <p v-if="block.type === 'text'">{{ block.value }}</p>
              <ol v-if="block.type === 'list'">
                <li v-for="(item, iIdx) in block.items" :key="'bl-' + idx + '-' + bIdx + '-' + iIdx">
                  {{ item }}
                </li>
              </ol>
            </template>
          </section>

          <section class="terms-article">
            <h2>부칙</h2>
            <p>이 약관은 2026년 2월 23일부터 시행합니다.</p>
          </section>
        </template>

        <!-- ===================== 개인정보처리방침 ===================== -->
        <template v-if="activeTab === 'privacy'">
          <div class="terms-doc-header">
            <div class="terms-doc-badge privacy">개인정보보호</div>
            <h1>보다(BODA) 개인정보처리방침</h1>
            <p class="terms-date">시행일: 2026년 2월 23일</p>
          </div>

          <section class="terms-article" v-for="(article, idx) in privacyArticles" :key="'p-' + idx">
            <h2>{{ article.title }}</h2>
            <template v-for="(block, bIdx) in article.blocks" :key="'pb-' + idx + '-' + bIdx">
              <p v-if="block.type === 'text'">{{ block.value }}</p>
              <ol v-if="block.type === 'list'">
                <li v-for="(item, iIdx) in block.items" :key="'pl-' + idx + '-' + bIdx + '-' + iIdx">
                  {{ item }}
                </li>
              </ol>
              <div v-if="block.type === 'table'" class="terms-table-wrap">
                <table class="terms-table">
                  <thead>
                    <tr>
                      <th v-for="(h, hIdx) in block.headers" :key="'th-' + hIdx">{{ h }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rIdx) in block.rows" :key="'tr-' + rIdx">
                      <td v-for="(cell, cIdx) in row" :key="'td-' + rIdx + '-' + cIdx">{{ cell }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="block.type === 'info'" class="terms-info-box">
                <p v-for="(line, lIdx) in block.lines" :key="'info-' + lIdx">{{ line }}</p>
              </div>
            </template>
          </section>

          <section class="terms-article">
            <h2>부칙</h2>
            <p>이 개인정보처리방침은 2026년 2월 23일부터 시행합니다.</p>
          </section>
        </template>
      </div>
    </main>

    <!-- 푸터 -->
    <footer class="terms-footer">
      <div class="terms-footer-inner">
        <p class="terms-footer-company">보다(BODA)</p>
        <p class="terms-footer-copy">&copy; 2026 BODA. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "TermsPage",
  setup() {
    const router = useRouter();
    const activeTab = ref("boda");

    const params = new URLSearchParams(window.location.search);
    const tabParam = params.get("tab");
    if (tabParam === "privacy") activeTab.value = "privacy";

    const goHome = () => { router.push("/"); };

    // ================================================================
    //  보다(BODA) 이용약관
    // ================================================================
    const bodaArticles = [
      {
        title: "제1조 (목적)",
        blocks: [
          { type: "text", value: '이 약관은 보다(BODA, 이하 "보다 서비스")를 운영하는 회사(이하 "회사")가 제공하는 보험 다이어리 서비스의 이용에 관하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.' }
        ]
      },
      {
        title: "제2조 (정의)",
        blocks: [
          { type: "list", items: [
            '"보다 서비스"란 회사가 보험 설계사의 업무 효율화를 위해 제공하는 B2B 솔루션으로서, 고객 관계 관리(CRM), 보험 계약 관리, 자동화 메시지 발송, 이벤트 관리 등의 기능을 포함합니다.',
            '"설계사 이용자"란 보다 서비스를 이용하는 보험 설계사 및 관련 업무 종사자를 말합니다.',
            '"고객 정보"란 설계사 이용자가 보다 서비스에 입력·저장하는 보험 계약자 및 피보험자의 개인정보, 계약 정보 등을 말합니다.'
          ]}
        ]
      },
      {
        title: "제3조 (서비스의 내용)",
        blocks: [
          { type: "text", value: "보다 서비스는 다음의 기능을 제공합니다." },
          { type: "list", items: [
            "고객 관계 관리(CRM): 고객 정보 등록·조회·수정, 태그 기반 분류, 가족 관계 관리, 고객 상담 이력 관리",
            "보험 계약 관리: 계약 정보 등록·조회, 보장 분석, 만기 관리, 계약 현황 대시보드",
            "자동화 메시지 발송: 생일 축하, 계약 기념일, 만기 안내 등 SMS/MMS 자동 발송 기능",
            "출석 체크 및 이벤트: 고객 참여 유도를 위한 출석 체크, 룰렛 등 이벤트 기능",
            "일정 및 업무 관리: 일정 등록, 알림, 업무 현황 대시보드",
            "기타 회사가 보다 서비스 내에서 추가로 제공하는 기능"
          ]}
        ]
      },
      {
        title: "제4조 (이용 자격 및 계정)",
        blocks: [
          { type: "list", items: [
            "보다 서비스는 회원가입을 완료한 이용자에 한하여 이용할 수 있습니다.",
            "설계사 이용자는 가입한 계정으로 보다 서비스에 로그인하며, 일부 기능의 이용을 위해 추가 정보 입력 또는 인증이 필요할 수 있습니다.",
            "설계사 이용자는 보다 서비스를 보험 영업 활동 지원의 목적으로만 이용하여야 하며, 이를 벗어난 목적으로의 이용은 제한될 수 있습니다."
          ]}
        ]
      },
      {
        title: "제5조 (고객 정보의 관리 및 책임)",
        blocks: [
          { type: "list", items: [
            "설계사 이용자가 보다 서비스에 입력하는 고객 정보(고객명, 연락처, 생년월일, 보험 계약 정보, 가족 관계 정보 등)에 대한 개인정보보호법상의 개인정보처리자로서의 책임은 해당 설계사 이용자에게 있습니다.",
            "설계사 이용자는 고객의 개인정보를 보다 서비스에 입력하기 전에 해당 고객으로부터 적법한 동의를 받아야 합니다.",
            "설계사 이용자는 입력한 고객 정보의 정확성을 유지하여야 하며, 고객의 정보 수정·삭제 요청에 대해 적시에 대응하여야 합니다.",
            "회사는 설계사 이용자가 입력한 고객 정보를 보다 서비스 제공 목적으로만 처리하며, 별도의 마케팅이나 제3자 제공에 이용하지 않습니다.",
            "설계사 이용자가 관련 법령을 위반하여 고객 정보를 처리함으로써 발생하는 모든 법적 책임은 해당 설계사 이용자에게 있습니다."
          ]}
        ]
      },
      {
        title: "제6조 (메시지 발송 서비스)",
        blocks: [
          { type: "list", items: [
            "보다 서비스의 메시지 발송 기능은 외부 문자 발송 서비스(Solapi 등)를 통해 제공되며, 발송 요금은 별도로 부과됩니다.",
            "설계사 이용자는 메시지 발송 시 정보통신망법, 개인정보보호법 등 관련 법령을 준수하여야 하며, 수신자의 사전 동의 없이 광고성 메시지를 발송하여서는 안 됩니다.",
            "메시지 발송 오류, 수신 불가 등 외부 통신사 또는 발송 서비스 제공업체의 사유로 인한 문제에 대하여 회사는 책임을 지지 않습니다.",
            "회사는 비정상적인 대량 발송, 스팸 발송 등이 확인될 경우 메시지 발송 기능의 이용을 제한할 수 있습니다."
          ]}
        ]
      },
      {
        title: "제7조 (유료 서비스 및 결제)",
        blocks: [
          { type: "list", items: [
            "보다 서비스의 일부 기능은 유료로 제공될 수 있으며, 유료 서비스의 내용 및 요금은 서비스 내에 별도로 안내합니다.",
            "유료 서비스의 결제, 환불 등에 관한 사항은 관련 법령에 따릅니다.",
            "회사는 유료 서비스의 요금을 변경할 수 있으며, 변경 시 30일 전에 이를 공지합니다."
          ]}
        ]
      },
      {
        title: "제8조 (서비스 이용 제한)",
        blocks: [
          { type: "text", value: "회사는 설계사 이용자가 다음 각 호에 해당하는 행위를 할 경우 보다 서비스의 이용을 제한할 수 있습니다." },
          { type: "list", items: [
            "고객 정보를 부정한 목적으로 수집·이용하는 행위",
            "관련 법령을 위반하여 고객에게 메시지를 발송하는 행위",
            "서비스의 기능을 악용하여 비정상적인 방법으로 데이터를 추출하는 행위",
            "이 약관에서 정한 이용자의 의무를 위반하는 행위",
            "기타 서비스의 정상적인 운영을 방해하는 행위"
          ]}
        ]
      },
      {
        title: "제9조 (데이터 보관 및 삭제)",
        blocks: [
          { type: "list", items: [
            "설계사 이용자가 보다 서비스 이용을 중단하거나 계정을 해지하는 경우, 서비스에 저장된 고객 정보 및 콘텐츠는 관련 법령에 따른 보유 기간이 경과한 후 파기합니다.",
            "회사는 이용 중단 전에 설계사 이용자가 데이터를 백업할 수 있도록 합리적인 기간 및 방법을 안내합니다.",
            "법령에 의하여 보존할 의무가 있는 경우에는 해당 기간 동안 데이터를 보관합니다."
          ]}
        ]
      },
      {
        title: "제10조 (지적재산권)",
        blocks: [
          { type: "list", items: [
            "보다 서비스에 관한 저작권 및 지적재산권은 회사에 귀속됩니다.",
            "설계사 이용자가 서비스에 입력한 고객 정보 및 콘텐츠에 대한 권리는 해당 이용자에게 귀속됩니다.",
            "설계사 이용자는 보다 서비스를 역설계, 디컴파일, 또는 소스코드를 추출하는 행위를 하여서는 안 됩니다."
          ]}
        ]
      },
      {
        title: "제11조 (기타)",
        blocks: [
          { type: "list", items: [
            "이 약관에서 정하지 아니한 사항은 관련 법령에 따릅니다."
          ]}
        ]
      }
    ];

    // ================================================================
    //  개인정보처리방침 (보다)
    // ================================================================
    const privacyArticles = [
      {
        title: "제1조 (개인정보의 처리 목적)",
        blocks: [
          { type: "text", value: '보다(BODA, 이하 "회사")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.' },
          { type: "list", items: [
            "회원 가입 및 관리: 회원제 서비스 이용에 따른 본인 확인, 서비스 부정이용 방지, 각종 고지·통지 목적",
            "서비스 제공: 보다(BODA) 서비스 제공, 고객 관리 기능 제공, 메시지 발송 서비스 제공",
            "서비스 개선: 서비스 이용 기록 분석, 서비스 개선 및 신규 서비스 개발",
            "마케팅 및 광고: 이벤트·광고성 정보 제공 및 참여 기회 제공(별도 동의 시)"
          ]}
        ]
      },
      {
        title: "제2조 (처리하는 개인정보의 항목)",
        blocks: [
          { type: "text", value: "회사는 다음의 개인정보 항목을 처리하고 있습니다." },
          { type: "table", headers: ["구분", "수집 항목", "수집 방법"],
            rows: [
              ["필수 항목 (회원가입)", "이름, 이메일 주소, 비밀번호, 휴대전화번호", "회원가입 시 이용자 직접 입력"],
              ["선택 항목 (프로필)", "프로필 사진, 소속 보험사, 직급, 사업자등록번호", "서비스 이용 중 이용자 직접 입력"],
              ["보다 서비스 — 고객 정보 (이용자 입력)", "고객명, 연락처, 생년월일, 주소, 보험 계약 정보, 가족 관계 정보, 메모", "설계사 이용자가 보다 서비스에 직접 입력"],
              ["자동 수집", "접속 IP, 접속 일시, 서비스 이용 기록, 기기 정보, 브라우저 종류", "서비스 이용 과정에서 자동 생성·수집"],
              ["소셜 로그인 (선택)", "소셜 계정 식별자, 이메일, 프로필 정보", "소셜 로그인 연동 시"]
            ]
          }
        ]
      },
      {
        title: "제3조 (개인정보의 처리 및 보유 기간)",
        blocks: [
          { type: "text", value: "회사는 법령에 따른 개인정보 보유·이용 기간 또는 이용자로부터 개인정보를 수집 시 동의받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다." },
          { type: "table", headers: ["구분", "보유 기간", "근거"],
            rows: [
              ["회원 정보", "회원 탈퇴 시까지", "서비스 이용 계약"],
              ["서비스 이용 기록", "3년", "통신비밀보호법"],
              ["계약 또는 청약철회 등에 관한 기록", "5년", "전자상거래법"],
              ["대금결제 및 재화 등의 공급에 관한 기록", "5년", "전자상거래법"],
              ["소비자 불만 또는 분쟁처리에 관한 기록", "3년", "전자상거래법"],
              ["표시·광고에 관한 기록", "6개월", "전자상거래법"]
            ]
          }
        ]
      },
      {
        title: "제4조 (개인정보의 제3자 제공)",
        blocks: [
          { type: "text", value: "회사는 이용자의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며, 이용자의 동의 없이 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다." },
          { type: "list", items: [
            "이용자가 사전에 동의한 경우",
            "법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우",
            "서비스 제공에 따른 요금 정산을 위하여 필요한 경우"
          ]}
        ]
      },
      {
        title: "제5조 (개인정보 처리의 위탁)",
        blocks: [
          { type: "text", value: "회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리업무를 위탁하고 있습니다." },
          { type: "table", headers: ["수탁업체", "위탁업무", "보유 기간"],
            rows: [
              ["Solapi(솔라피)", "문자메시지(SMS/MMS) 발송 [보다 서비스]", "위탁 계약 종료 시까지"],
              ["클라우드 서비스 제공업체", "데이터 저장 및 서버 운영", "위탁 계약 종료 시까지"],
              ["결제 대행사", "유료 서비스 결제 처리", "위탁 계약 종료 시까지"]
            ]
          },
          { type: "text", value: "회사는 위탁계약 체결 시 관련 법령에 따라 위탁업무 수행 목적 외 개인정보 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시합니다." }
        ]
      },
      {
        title: "제6조 (이용자 및 법정대리인의 권리·의무 및 행사방법)",
        blocks: [
          { type: "list", items: [
            "이용자는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.\n가. 개인정보 열람 요구\n나. 오류 등이 있을 경우 정정 요구\n다. 삭제 요구\n라. 처리 정지 요구",
            "제1항에 따른 권리 행사는 서비스 내 설정 메뉴 또는 개인정보보호 책임자에게 서면, 전자우편을 통하여 할 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.",
            "이용자가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다."
          ]}
        ]
      },
      {
        title: "제7조 (개인정보의 파기)",
        blocks: [
          { type: "text", value: "회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다." },
          { type: "list", items: [
            "파기 절차: 이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져 내부 방침 및 기타 관련 법령에 따라 일정 기간 저장된 후 혹은 즉시 파기됩니다.",
            "파기 방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다."
          ]}
        ]
      },
      {
        title: "제8조 (개인정보의 안전성 확보 조치)",
        blocks: [
          { type: "text", value: "회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다." },
          { type: "list", items: [
            "관리적 조치: 내부관리계획 수립·시행, 개인정보 취급 직원의 최소화 및 교육",
            "기술적 조치: 개인정보처리시스템에 대한 접근 권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치",
            "물리적 조치: 전산실, 자료보관실 등에 대한 접근 통제"
          ]}
        ]
      },
      {
        title: "제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)",
        blocks: [
          { type: "text", value: "회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 '쿠키(Cookie)'를 사용합니다." },
          { type: "text", value: "이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 웹브라우저 설정을 통해 쿠키의 설치를 허용하거나 거부할 수 있습니다. 다만, 쿠키 설치를 거부할 경우 서비스 이용에 어려움이 발생할 수 있습니다." }
        ]
      },
      {
        title: "제10조 (보다 서비스 — 이용자가 입력한 고객 정보의 처리)",
        blocks: [
          { type: "text", value: "보다(BODA) 서비스의 특성상 설계사 이용자가 서비스에 입력하는 고객 정보와 관련하여 다음 사항을 안내드립니다." },
          { type: "list", items: [
            "설계사 이용자가 보다 서비스에 입력하는 고객 정보(고객명, 연락처, 생년월일, 보험 계약 정보 등)에 대한 개인정보보호법상의 개인정보처리자로서의 책임은 해당 설계사 이용자에게 있습니다.",
            "설계사 이용자는 고객의 개인정보를 서비스에 입력하기 전에 해당 고객으로부터 적법한 동의를 받아야 합니다.",
            "회사는 설계사 이용자가 입력한 고객 정보를 보다 서비스 제공 목적으로만 처리하며, 별도의 마케팅이나 제3자 제공에 이용하지 않습니다.",
            "설계사 이용자의 서비스 탈퇴 시 해당 이용자가 입력한 고객 정보는 관련 법령에 따른 보유 기간이 경과한 후 파기합니다."
          ]}
        ]
      },
      {
        title: "제11조 (개인정보보호 책임자)",
        blocks: [
          { type: "text", value: "회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호 책임자를 지정하고 있습니다." },
          { type: "info", lines: [
            "▶ 개인정보보호 책임자",
            "성명: [책임자 성명]",
            "직책: [직책]",
            "연락처: [이메일], [전화번호]"
          ]},
          { type: "text", value: "이용자는 서비스를 이용하면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보보호 책임자에게 문의하실 수 있습니다." }
        ]
      },
      {
        title: "제12조 (권익침해 구제방법)",
        blocks: [
          { type: "text", value: "이용자는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다." },
          { type: "info", lines: [
            "▶ 개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)",
            "▶ 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)",
            "▶ 대검찰청: (국번없이) 1301 (www.spo.go.kr)",
            "▶ 경찰청: (국번없이) 182 (ecrm.cyber.go.kr)"
          ]}
        ]
      },
      {
        title: "제13조 (개인정보처리방침의 변경)",
        blocks: [
          { type: "text", value: "이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 서비스 공지사항을 통하여 고지할 것입니다." }
        ]
      }
    ];

    return { activeTab, goHome, bodaArticles, privacyArticles };
  },
};
</script>

<style scoped>
.terms-container { width:100%; min-height:100vh; display:flex; flex-direction:column; background:var(--color-primary,#f5f7fa); }

/* 헤더 */
.terms-header { position:sticky; top:0; z-index:100; background:var(--color-background,#fff); border-bottom:1px solid var(--color-border,#e2e8f0); backdrop-filter:blur(12px); }
.terms-header-inner { max-width:960px; margin:0 auto; padding:16px 24px; display:flex; align-items:center; justify-content:space-between; }
.terms-logo { display:flex; align-items:center; gap:10px; cursor:pointer; }
.terms-logo img { width:36px; height:36px; object-fit:cover; }
.terms-logo span { font-size:var(--font-size-xl,20px); font-weight:var(--font-weight-extrabold,800); color:var(--color-brand,#20a0b4); }
.terms-back-btn { display:flex; align-items:center; gap:6px; padding:8px 16px; border:1px solid var(--color-border,#e2e8f0); border-radius:100px; background:var(--color-background,#fff); color:var(--color-text-primary,#333); font-size:var(--font-size-sm,14px); font-weight:500; cursor:pointer; transition:all .2s; }
.terms-back-btn:hover { background:var(--color-primary,#f5f7fa); border-color:var(--color-brand,#20a0b4); color:var(--color-brand,#20a0b4); }

/* 탭 */
.terms-tab-wrap { background:var(--color-background,#fff); border-bottom:1px solid var(--color-border,#e2e8f0); }
.terms-tabs { max-width:960px; margin:0 auto; padding:0 24px; display:flex; overflow-x:auto; -webkit-overflow-scrolling:touch; }
.terms-tab { padding:14px 20px; border:none; background:none; font-size:var(--font-size-md,15px); font-weight:600; color:var(--color-text-secondary,#999); cursor:pointer; position:relative; transition:color .2s; white-space:nowrap; flex-shrink:0; }
.terms-tab:hover { color:var(--color-text-primary,#333); }
.terms-tab.active { color:var(--color-brand,#20a0b4); }
.terms-tab.active::after { content:""; position:absolute; left:0; right:0; bottom:-1px; height:3px; background:var(--color-brand,#20a0b4); border-radius:3px 3px 0 0; }

/* 콘텐츠 */
.terms-content { flex:1; max-width:960px; width:100%; margin:0 auto; padding:32px 24px 64px; box-sizing:border-box; }
.terms-paper { background:var(--color-background,#fff); border-radius:16px; padding:48px; box-shadow:0 1px 3px rgba(0,0,0,.06); border:1px solid var(--color-border,#e2e8f0); }

/* 문서 헤더 */
.terms-doc-header { text-align:center; margin-bottom:40px; padding-bottom:32px; border-bottom:2px solid var(--color-brand,#20a0b4); }
.terms-doc-badge { display:inline-block; padding:4px 14px; border-radius:100px; font-size:12px; font-weight:700; letter-spacing:.5px; background:var(--color-brand,#20a0b4); color:#fff; margin-bottom:16px; }
.terms-doc-badge.boda { background:#2d6a4f; }
.terms-doc-badge.privacy { background:#6c5ce7; }
.terms-doc-header h1 { font-size:var(--font-size-2xl,26px); font-weight:var(--font-weight-extrabold,800); color:var(--color-text-primary,#222); margin:0 0 6px; line-height:1.4; }
.terms-sub { font-size:var(--font-size-md,15px); color:var(--color-text-secondary,#777); margin:0 0 6px; }
.terms-date { font-size:var(--font-size-sm,13px); color:var(--color-text-secondary,#999); margin:0; }

/* 안내 박스 */
.terms-notice-box { display:flex; align-items:flex-start; gap:10px; background:#f0f7ff; border:1px solid #bdd7ee; border-radius:10px; padding:16px 20px; margin-bottom:32px; }
.terms-notice-box i { font-size:20px; color:#3b82f6; flex-shrink:0; margin-top:2px; }
.terms-notice-box p { margin:0; font-size:var(--font-size-sm,14px); line-height:1.7; color:#1e3a5f; }

/* 조항 */
.terms-article { margin-bottom:32px; }
.terms-article h2 { font-size:var(--font-size-lg,17px); font-weight:700; color:var(--color-brand,#20a0b4); margin:0 0 12px; padding-left:12px; border-left:3px solid var(--color-brand,#20a0b4); }
.terms-article p { font-size:var(--font-size-md,15px); line-height:1.85; color:var(--color-text-primary,#333); margin:0 0 10px; white-space:pre-line; }
.terms-article ol { margin:8px 0 16px; padding-left:24px; }
.terms-article ol li { font-size:var(--font-size-md,15px); line-height:1.85; color:var(--color-text-primary,#333); margin-bottom:6px; white-space:pre-line; }

/* 테이블 */
.terms-table-wrap { overflow-x:auto; margin:12px 0 16px; border-radius:8px; border:1px solid var(--color-border,#e2e8f0); }
.terms-table { width:100%; border-collapse:collapse; font-size:var(--font-size-sm,14px); }
.terms-table th { background:var(--color-brand,#20a0b4); color:#fff; font-weight:600; padding:12px 14px; text-align:left; white-space:nowrap; }
.terms-table td { padding:10px 14px; border-bottom:1px solid var(--color-border,#e2e8f0); color:var(--color-text-primary,#333); line-height:1.6; }
.terms-table tbody tr:last-child td { border-bottom:none; }
.terms-table tbody tr:nth-child(even) { background:var(--color-primary,#f8fafb); }

/* 정보 박스 */
.terms-info-box { background:var(--color-primary,#f5f7fa); border-radius:10px; padding:16px 20px; margin:12px 0 16px; border-left:3px solid var(--color-brand,#20a0b4); }
.terms-info-box p { margin:0 0 4px; font-size:var(--font-size-sm,14px); line-height:1.7; color:var(--color-text-primary,#444); }
.terms-info-box p:last-child { margin-bottom:0; }

/* 푸터 */
.terms-footer { text-align:center; padding:24px; border-top:1px solid var(--color-border,#e2e8f0); background:var(--color-background,#fff); }
.terms-footer-inner { max-width:960px; margin:0 auto; }
.terms-footer-company { margin:0 0 4px; font-size:var(--font-size-sm,13px); font-weight:600; color:var(--color-text-primary,#555); }
.terms-footer-copy { margin:0; font-size:12px; color:var(--color-text-secondary,#999); }

/* 반응형 */
@media screen and (max-width:768px) {
  .terms-header-inner { padding:12px 16px; }
  .terms-logo img { width:28px; height:28px; }
  .terms-logo span { font-size:var(--font-size-lg,17px); }
  .terms-tabs { padding:0 12px; }
  .terms-tab { padding:12px 14px; font-size:var(--font-size-sm,13px); }
  .terms-content { padding:16px 12px 48px; }
  .terms-paper { padding:28px 20px; border-radius:12px; }
  .terms-doc-header h1 { font-size:var(--font-size-xl,21px); }
  .terms-article h2 { font-size:var(--font-size-md,15px); }
  .terms-article p, .terms-article ol li { font-size:var(--font-size-sm,14px); }
  .terms-table { font-size:13px; }
  .terms-table th, .terms-table td { padding:8px 10px; }
  .terms-notice-box { padding:12px 14px; }
  .terms-notice-box p { font-size:13px; }
}
@media screen and (max-width:480px) {
  .terms-back-btn { padding:6px 12px; font-size:12px; }
  .terms-paper { padding:20px 16px; }
  .terms-doc-header { margin-bottom:24px; padding-bottom:20px; }
  .terms-doc-header h1 { font-size:var(--font-size-lg,18px); }
  .terms-article { margin-bottom:24px; }
}
</style>